import * as React from 'react';
import { mergeStyles } from '@fluentui/react/lib/Styling';
import { Spinner, SpinnerSize, ISpinnerStyles } from '@fluentui/react/lib/Spinner';
import { gridUnit, gridSubUnit } from '@uifabric/portal-ux/lib/styling/stylingConstants';
import { useLocalization } from '@microsoft/portal-app/lib/shared/localization';

export interface IContactPreferenceFooterProps {
  activity?: 'loading' | 'saving';
  children?: React.ReactNode;
}

export const ContactPreferenceFooter = ({ activity, children }: IContactPreferenceFooterProps): React.ReactElement => {
  const [t] = useLocalization('Privacy');
  const className = mergeStyles({
    displayName: 'ContactPreferenceFooter',
    margin: `${gridSubUnit * 5}px 0`,
    display: 'flex',
    alignItems: 'center',
  });

  return (
    <div className={className}>
      {children}
      {activity && (
        <Spinner styles={spinnerStyles} size={SpinnerSize.small} labelPosition={'right'} label={t(activity)} />
      )}
    </div>
  );
};

const spinnerStyles: ISpinnerStyles = {
  root: {
    selectors: {
      ':not(:first-child)': {
        marginLeft: `${gridUnit * 2}px`
      }
    }
  }
};
